Ext.define('SA.HistogramModel', {
    alias: 'view.histogram',
    extend: 'SA.data.View',

    statics: {
        create({project, censusRelease, name}) {
            return SA.HistogramModelFactory.create({project, censusRelease, name});
        }
    },

    hasDataMap: false,

    constructor() {
        this.callParent(arguments);

        this.data.type = 'histogram';
        this.data.filterVisibility = 'strikeout';
    },

    clearLocation() {
        this.setData({location: null});
    },

    createController() {
        return new SA.HistogramController(this);
    },

    getAttribute() {
        return this.data.attribute;
    },

    getAttributes() {
        return Ext.Array.from(this.getAttribute());
    },

    getGeoUnit() {
        return this.data.geographicUnit;
    },

    getLocation() {
        return SA.data.LocationsCache.toLocationSeries(this.data.locationItem);
    },

    getLocations() {
        return Ext.Array.from(this.getLocation());
    },

    getSupportedDiscoverableGeoUnits() {
        return SA.HistogramGeoUnits.getSupportedDiscoverableUnitsForModel(this);
    },

    getState() {
        return SA.HistogramModelState.get(this);
    },

    isSavable() {
        return !!this.getAttribute() && !!this.getLocation();
    },

    maybeResetGeoUnit() {
        this.setData({geographicUnit: this.getGeoUnit()});
    },

    onCustomLocationUpdate(location) {
        if (!this.sameLocation(location)) {
            return;
        }
        else if (!this.supportsLocation(location)) {
            this.clearLocation();
            return;
        }

        this.maybeResetGeoUnit(); 
    },

    removeAttribute(attribute) {
        if (SA.data.AttributesCache.sameAttribute(attribute, this.getAttribute())) {
            this.setData({attribute: null});
        }
    },

    removeLocation(location) {
        if (this.sameLocation(location)) {
            this.clearLocation();
        }
    },

    sameLocation(location) {
        return SA.data.LocationsCache.sameLocation(location, this.getLocation());
    },

    setData(data) {
        var sets = property => Reflect.has(data, property),
            getNewOrCurrent = property => sets(property) ? data[property] : this.data[property],
            setsLocation = sets('location'), 
            attribute = getNewOrCurrent('attribute'),
            location = setsLocation ? data.location : this.data.locationItem,
            locationItem = SA.data.LocationsCache.toLocationItem(location),
            preferredUnit = getNewOrCurrent('geographicUnit'),
            discoverableUnits = this.getDiscoverableGeoUnits(),
            geographicUnit = SA.HistogramGeoUnits.resolveUnit({location, attribute, preferredUnit, discoverableUnits}),
            binSize = sets('binSize') ? data.binSize : (sets('attribute') ? null : this.data.binSize); 

        Reflect.deleteProperty(data, 'location'); 

        this.data = {...this.data, ...data, attribute, locationItem, geographicUnit, binSize};
        this.save();

        if (sets('attribute')) {
            this.fireEvent('change:attribute');
        }
        else if (setsLocation) {
            this.fireEvent('change:location');
        }

        this.fireEvent('set:data');
    },

    supportsAttribute(attribute) {
        return SA.HistogramAttributes.isSupported({attribute, censusRelease: this.getCensusRelease()});
    },

    supportsLocation(location) {
        return SA.HistogramLocations.isSupported({location, country: this.getCountry(), censusRelease: this.getCensusRelease()});
    }
});